export { default } from './FormLabel';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/FormLabel/index.js
// module id = 588
// module chunks = 121